module.exports = __webpack_public_path__ + "5bf03fa1.svg";